// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__gOtFu","load2":"Spinner_load2__TUBj0"};